









































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

import commentServices from '@/services/comment-services';
import { Comment } from '@/models/comment';
import { APP_CONFIG } from '@/config/app-config'
@Component
export default class ChatBox extends Vue {
    @Prop({default: 0})
    private orderId!: number;

    @Prop({default: 1})
    private orderType!: number;

    private comment: string = '';
    private listComment: Comment[] = [];
    private timer: any;
    private uploading: boolean = false;

    private isBlockEnter = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        this.timer = setInterval(() => {
            this.loadComment();
        }, APP_CONFIG.notifyRefreshTime * 1000);
    }

    private async destroyed() {
        clearInterval(this.timer);
    }

    @Watch('orderId', { immediate: true, deep: true })
    private async loadComment() {
        if (this.orderId > 0) {
            const result: any = await commentServices.getComment(this.orderId, this.orderType);
            if(result && result.data.status === 200 && result.data.message === 'Success') {
                const arrComment: any = [];
                for (const item of result.data.data) {
                    arrComment.push({
                        ...item,
                        CreatedDate: moment(item.CreatedDate).format('DD-MM-YYYY hh:mm:ss')
                    });
                }

                this.listComment = arrComment;
            }
            this.setScroll();
        }
    }

    private isImage(text: string): boolean {
        if (!text || typeof text !== 'string') {
            return false;
        }
        const urlWithoutParams = text.split('?')[0].split('#')[0];
        return (
            text.startsWith('http') &&
            /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(urlWithoutParams)
        );
    }

    private triggerImageUpload() {
        (this.$refs.imageUploader as HTMLElement).click();
    }

    private onImageSelected(e: any) {
        const file = e.target.files[0];
        if (!file) {
            return;
        }
        this.uploadImageFile(file);
        (this.$refs.imageUploader as HTMLInputElement).value = '';
    }

    private onPaste(e: any) {
        const clipboardData = e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData);
        if (!clipboardData) {
            return;
        }
        const items = clipboardData.items;
        for (const index in items) {
            const item = items[index];
            if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
                const blob = item.getAsFile();
                if (blob) {
                    this.uploadImageFile(blob);
                    e.preventDefault();
                }
            }
        }
    }

    private async uploadImageFile(file: File | Blob) {
        this.uploading = true;
        try {
            const res: any = await commentServices.uploadR2File(file);
            this.uploading = false;
            if (res && res.data && res.data.status === 200 && res.data.data && res.data.data.url) {
                const imageUrl = res.data.data.url;
                const commentModel: Comment = {
                    OrderID: this.orderId,
                    Comment: imageUrl,
                    Status: 1,
                    Type: 1,
                    OrderType: this.orderType,
                    CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
                };
                const result = await commentServices.addComment(commentModel);
                if (result && result.data && result.data.status === 200) {
                    this.loadComment();
                }
            } else {
                const msg = (res && res.data && (res.data.message || res.data.reason)) || 'Lỗi không xác định';
                alert('Upload ảnh thất bại: ' + msg);
            }
        } catch (err) {
            this.uploading = false;
            alert('Lỗi kết nối khi upload ảnh.');
        }
    }

    private onCommentKeyup(e: any) {
        if(e.keyCode === 13) {
            e.preventDefault();
            this.addComment();
        }
    }
    
    private async addComment() {
        if (this.comment.trim().length > 0 && this.isBlockEnter === false) {
            this.isBlockEnter = true;
            const commentModel: Comment = {
                OrderID: this.orderId,
                Comment: this.comment,
                Status: 1,
                Type: 1,
                OrderType: this.orderType,
                CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
            };
            const result = await commentServices.addComment(commentModel);
            this.comment = '';
            this.isBlockEnter = false;
            if (result.data.status === 200) {
                this.loadComment();
            }
        }
    }

    private setScroll() {
        setTimeout(() => {
            const boxMess: any = this.$el.querySelector('.content-message');
            if (boxMess) {
                boxMess.scrollTop = boxMess.scrollHeight;
            }
        }, 0);
    }
}
